import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {initialize, reduxForm, Field} from 'redux-form';
import {injectIntl} from 'react-intl';
import classNames from 'classnames';

import * as authActions from '../actions/auth';
import FlashMessage from './FlashMessage';
import TextInput from './Form/TextInput';
import CheckboxInput from './Form/CheckboxInput';
import validate from '../validators/forms/central';
import * as types from '../types';

const FORM_NAME = 'central-form';

class CentralForm extends Component {
  constructor(props) {
    super(props);

    this.identifierField =
      props.xl.isUsernameEmail || props.xl.proxy.resetPassword ? 'email' : 'username';

    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentWillMount() {
    const {dispatch, xl} = this.props;

    this.hideCaptcha(dispatch, xl);
  }

  componentDidMount() {
    const initialFormData = {
      [this.identifierField]: this.props.auth.login.values[this.identifierField],
      remember_me: true
    };

    this.props.dispatch(initialize('central-form', initialFormData));
  }

  handleChange(event) {
    if (event.target.name === 'email') {
      authActions.setEmail(this.props.dispatch, event.target.value);
    }
    if (event.target.name === 'username') {
      authActions.setUsername(this.props.dispatch, event.target.value);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  hideCaptcha(dispatch, xl) {
    if (xl.captcha.visible) {
      dispatch({type: types.HIDE_CAPTCHA});
      if (xl.captcha.value) {
        dispatch({type: types.REMOVE_RECAPTCHA});
      }
    }

    if (xl.chineseCaptcha.visible) {
      dispatch({type: types.HIDE_CHINESE_CAPTCHA});

      if (xl.chineseCaptcha.values) {
        dispatch({type: types.REMOVE_CHINESE_CAPTCHA});
      }
    }

    dispatch({type: types.REGISTRATION_STOP});
  }

  handleFormSubmit(values) {
    authActions.loginAsync(this.props.dispatch, values, this.props.location.query, this.props.xl);
  }

  render() {
    const {intl, auth, handleSubmit, xl, showRememberMe, className} = this.props;

    return (
      <div className={classNames('central-form', className)}>
        {auth.login.error !== null && <FlashMessage type="error" message={auth.login.error} />}

        <form onSubmit={handleSubmit(this.handleFormSubmit)}>
          <Field
            component={TextInput}
            name={this.identifierField}
            type="text"
            label={intl.messages[`form.${this.identifierField}`]}
            required="true"
            icon="user"
            disabled={auth.login.loading}
            onChange={this.handleChange}
          />
          <Field
            component={TextInput}
            name="password"
            type="password"
            label={intl.messages['form.password']}
            required="true"
            icon="password"
            disabled={auth.login.loading}
          />

          {showRememberMe && (
            <CheckboxInput name="remember_me" label={intl.messages['form.remember_me']} />
          )}

          <button
            type="submit"
            className="form-button button-with-bg"
            disabled={auth.login.loading || xl.captcha.visible}
          >
            {auth.login.loading ? intl.messages['form.loading'] : intl.messages['form.signin']}
          </button>
        </form>
      </div>
    );
  }
}

CentralForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  showRememberMe: PropTypes.bool.isRequired,
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  intl: PropTypes.object,
  xl: PropTypes.object.isRequired
};

CentralForm.defaultProps = {
  showRememberMe: true
};

function mapStateToProps(state) {
  return {
    ...state,
    ...validate(state.xl.isUsernameEmail),
    form: FORM_NAME
  };
}

export default injectIntl(connect(mapStateToProps)(reduxForm()(CentralForm)));



// WEBPACK FOOTER //
// ./components/CentralForm.jsx